import '../../styles/components/locations-drawer.scss';

import React from "react";
import { createRoot } from 'react-dom/client';
import { LocationsDrawer } from "../react_components/LocationsDrawer.js";
import { APIProvider } from '@vis.gl/react-google-maps';

const rootElements = Array.from(document.querySelectorAll('[data-locations-drawer-target]'));

// creates the roots to render the react components

if (rootElements?.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    if (root) {
      root.render(
        <APIProvider apiKey={rootEl.dataset.locationsDrawerTarget}>
          <LocationsDrawer drawerName={rootEl.dataset.locationsDrawerName} />
        </APIProvider>
      );
      rootEl._reactRootContainer = root;
    }
  });
}
